import { c as _c } from "react/compiler-runtime";
import cn from 'classnames';
import type { Flag } from '../../../types';
import { useFlag } from '../use-flag';
import css from './select.module.scss';
interface Props {
  flag: Flag;
}
export function Select(t0) {
  const $ = _c(18);
  const {
    flag
  } = t0;
  const {
    value,
    onChange,
    disabled
  } = useFlag(flag);
  const t1 = flag.id;
  const t2 = value as string;
  let t3;
  if ($[0] !== onChange) {
    t3 = e => onChange(e.target.value);
    $[0] = onChange;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <button><selectedcontent /><span className={css.arrow}>⌃</span></button>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== disabled || $[4] !== flag.options || $[5] !== value) {
    let t6;
    if ($[7] !== disabled || $[8] !== value) {
      t6 = variant => <option key={variant} value={variant} className={cn(css.option, {
        [css.selected]: variant === value,
        [css.hide]: disabled
      })}>{variant}</option>;
      $[7] = disabled;
      $[8] = value;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = flag.options.map(t6);
    $[3] = disabled;
    $[4] = flag.options;
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[10] !== disabled) {
    t6 = disabled && <option className={css.empty} disabled={true}><span className={css.icon}>⊗</span><span className={css.text}>The flag’s rules block the other options</span></option>;
    $[10] = disabled;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== flag.id || $[13] !== t2 || $[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <select id={t1} className={css.select} value={t2} onChange={t3}>{t4}{t5}{t6}</select>;
    $[12] = flag.id;
    $[13] = t2;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
}